const MODES = [
    // { name: "Marathon", maximumTime: "36000000" },
    // { name: "Einzelmodus", maximumTime: "5400000" },
    // { name: "Paarmodus", maximumTime: "3600000" },
    // { name: "Puzzle-Schach-Qualifikation", maximumTime: "900000" },
    // { name: "Puzzle-Schach-Finalrunden", maximumTime: "480000" },

    // { id: 12, name: "Chaosmodus", maximumTime: "5400000" },
    // { id: 13, name: "Puzzle-Schach-Turnier", maximumTime: "900000" },
    // { id: 14, name: "Paarmodus-Relay", maximumTime: "5400000" },
    // { id: 16, name: "Zufallspaarmodus-Relay", maximumTime: "2700000" },
    // { id: 15, name: "Blindmodus", maximumTime: "5400000" },

    // { id: 7, name: "Marathon 2025", maximumTime: "36000000" },
    { id: 19, name: "Solo Marathon 2026", maximumTime: "36000000" },

]

export default MODES;